module.exports = __webpack_public_path__ + "static/media/list.885c2ed2.svg";